/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const id_card_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.531 5.594H3.97a1.313 1.313 0 0 0-1.313 1.312V18.72a1.312 1.312 0 0 0 1.313 1.31h17.06a1.312 1.312 0 0 0 1.313-1.312V6.906a1.312 1.312 0 0 0-1.313-1.312h-6.56m0 6.562h3.937m-3.937 2.625h5.25m-5.25-9.844a1.969 1.969 0 0 0-3.938 0v2.625a.656.656 0 0 0 .656.657h2.626a.656.656 0 0 0 .656-.656V4.938Zm-2.953 8.204a2.297 2.297 0 1 1-4.594 0 2.297 2.297 0 0 1 4.594 0ZM5.28 20.03a3.938 3.938 0 0 1 7.875 0H5.281Z"
    />
  </svg>
)
export default id_card_medium
